module.exports = __webpack_public_path__ + "img/subtitle1.289832cb.png";